import React from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';
import CredentialsPage from 'pages/Credentials/CredentialsPage';
import './App.scss';

export type MenuItem = {
  icon: React.ReactElement | null;
  title: string;
  path: string;
  children?: MenuItem[];
  separator?: boolean;
};

function App() {
  return (
    <main>
      <div className="app-main-content">
        <Routes>
          <Route path="/credentials" element={<CredentialsPage />} />
          <Route path="*" element={<Navigate to="/credentials" />} />
        </Routes>
      </div>
    </main>
  );
}

export default App;
